import React, {PropTypes} from 'react';
import { Link,browserHistory } from 'react-router'

const Paginate = (props) => {

	let items = props.items;
	let currentPage = props.currentPage;
	let itemsPerPages = props.itemsPerPage;
	let totalPages = Math.ceil(items.length/itemsPerPages);
	let pages = [];
	for(let i=1; i<=totalPages; i++ ){
		let pageActive = '';
			if(i == currentPage){
				pageActive = 'active green';
			}
 			pages.push(<li key={i} className={pageActive}><Link to={"/dashboard/"+i}> {i}</Link></li>);

	}
	let nextPage = parseInt(currentPage)+1;
	let previusPage = parseInt(currentPage)-1;
	let previusLink = <li key="left" ><Link to={"/dashboard/"+previusPage}><i className="material-icons">chevron_left</i></Link></li>;
	let nextLink = <li key="rigth" ><Link to={"/dashboard/"+nextPage}><i className="material-icons">chevron_right</i></Link></li>;
	if(nextPage > totalPages){
		nextLink = <li><i className="material-icons">chevron_right</i></li>;
	}
	if(previusPage == 0){
		previusLink = <li><i className="material-icons">chevron_left</i></li>;
	}


	return(
	 <ul className="pagination center">
    {previusLink}
   	{pages}
    {nextLink}
  </ul>
  )

	};


export default Paginate;



// WEBPACK FOOTER //
// ./src/components/Paginate.js